import { render } from "./Logo.vue?vue&type=template&id=0c19e097&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"

import "./Logo.vue?vue&type=style&index=0&id=0c19e097&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0c19e097"

export default script